import { RequestsTabController } from './requests-tab.controller'

function requestsTab () {
  return {
    restrict: 'E',
    templateUrl: '/workflow/directives/requests-tab/requests-tab-directive.html?$$REVISION$$',
    controller: RequestsTabController,
    scope: {
      isTabSelected: '<',
      isFiltering: '=',
      filterOnLoad: '=',
      tabCount: '='
    }
  }
}

export { requestsTab }
